import $ from 'jquery';
import 'pickadate/lib/picker';
import 'pickadate/lib/picker.date';
import 'pickadate/lib/picker.time';

// TODO: Make format configurable
export default function bind() {
  $('.pickdatepicker').pickadate({
    min: new Date(),
    formatSubmit: 'yyyy/mm/dd',
  });
  $('.picktimepicker:not(.required)').pickatime({
    format: 'HH:i',
  });
  $('.picktimepicker.required').pickatime({
    format: 'HH:i',
    clear: '',
  });
}



// WEBPACK FOOTER //
// ./src/plugins/date.js